import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { ReplyDetail } from './pages/ReplyDetail';
import { Engagement } from './pages/Engagement';
import { Templates } from './pages/Templates';
import { Outreach } from './pages/Outreach';
import { Podcast } from './pages/Podcast';
import { Interviews } from './pages/Interviews';
import { PainPoints } from './pages/PainPoints';
import { UserStories } from './pages/UserStories';
import { SettingsBucket } from './pages/SettingsBucket';

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              {/* Default landing → Outreach (Inbox tab). */}
              <Route path="/" element={<Navigate to="/outreach" replace />} />

              {/* Buckets. */}
              <Route path="/outreach" element={<Outreach />} />
              <Route path="/engagement" element={<Engagement />} />
              <Route path="/templates" element={<Templates />} />
              <Route path="/podcast" element={<Podcast />} />
              <Route path="/interviews" element={<Interviews />} />
              <Route path="/pain-points" element={<PainPoints />} />
              <Route path="/user-stories" element={<UserStories />} />
              <Route path="/settings" element={<SettingsBucket />} />

              {/* Reply detail is a deep view, not part of the Inbox list table. */}
              <Route path="/inbox/:email_id" element={<ReplyDetail />} />

              {/* Redirects for old top-level URLs so bookmarks survive. */}
              <Route path="/inbox" element={<Navigate to="/outreach?tab=inbox" replace />} />
              <Route path="/creators" element={<Navigate to="/outreach?tab=creators" replace />} />
              <Route path="/meetings" element={<Navigate to="/outreach?tab=meetings" replace />} />
              <Route path="/system" element={<Navigate to="/settings?tab=system" replace />} />
              <Route path="/senders" element={<Navigate to="/settings?tab=senders" replace />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
